/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_TitleInputs */

const en_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QuickTools Settings`)
};

const fr_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres QuickTools`)
};

const de_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QuickTools-Einstellungen`)
};

const it_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni QuickTools`)
};

const ru_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки быстрых инструментов`)
};

const es_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de QuickTools`)
};

const zh_cn2_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速工具设置`)
};

const ja_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイックツール設定`)
};

const hi_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्विकटूल्स सेटिंग्स`)
};

const pt_pt2_options_quicktools_title = /** @type {(inputs: Options_Quicktools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações do QuickTools`)
};

/**
* | output |
* | --- |
* | "QuickTools Settings" |
*
* @param {Options_Quicktools_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_title = /** @type {((inputs?: Options_Quicktools_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_title(inputs)
	if (locale === "de") return de_options_quicktools_title(inputs)
	if (locale === "it") return it_options_quicktools_title(inputs)
	if (locale === "ru") return ru_options_quicktools_title(inputs)
	if (locale === "es") return es_options_quicktools_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_title(inputs)
	if (locale === "ja") return ja_options_quicktools_title(inputs)
	if (locale === "hi") return hi_options_quicktools_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_title(inputs)
	return en_options_quicktools_title(inputs)
});